(ns minorodata.app.posthog
  (:require ["posthog-js" :default posthog]
            [clojure.string :as str]
            [minorodata.app.handlers :refer [reg-fx]]
            [re-frame.core :as re-frame]))

(defonce initialized? (atom false))

(defn- clean-url [url]
  (first (str/split url #"\?")))

(defn- current-url-without-query []
  (str (.-origin js/location)
       (.-pathname js/location)))

(defn- auth-callback-url? []
  (= "/login-callback" (.-pathname js/location)))

(defn- sanitize-event [event]
  (let [properties (aget event "properties")]
    (when properties
      (aset properties "$current_url" (current-url-without-query))

      (when-let [referrer (aget properties "$referrer")]
        (aset properties "$referrer" (clean-url referrer))))

    event))

(defn- parsed-local-storage [storage-key]
  (try
    (js/JSON.parse (js/localStorage.getItem storage-key))
    (catch :default _ nil)))

(defn- expanded-flag [value]
  (if (nil? value) true (boolean value)))

(defn- ui-preference-props []
  {:sidebar-expanded      (expanded-flag (some-> (parsed-local-storage "navbar")
                                                 (aget "initial-expand")))
   :overview-kai-expanded (expanded-flag (parsed-local-storage "overview-kai-expanded"))
   :dark-mode             (boolean (parsed-local-storage "dark-mode"))})

(defn- init-sdk! [{:keys [project-token api-host environment]}]
  (when (and (not @initialized?)
             (not (auth-callback-url?))
             (seq project-token)
             (seq api-host))
    (.init posthog
           project-token
           #js {:api_host api-host
                :capture_pageview "history_change"
                :capture_pageleave true
                :autocapture true
                :before_send sanitize-event})
    (.register posthog #js {:environment environment})
    (reset! initialized? true)))

(reg-fx
 :posthog/init
 init-sdk!)

(re-frame/reg-event-fx
 :posthog/init
 (fn [_ [_ config]]
   {:posthog/init config}))

(reg-fx
 :posthog/identify
 (fn [{:keys [user-id props]}]
   (when (seq user-id)
     (.identify posthog user-id (clj->js (merge (ui-preference-props) props))))))

(reg-fx
 :posthog/set-person-properties
 (fn [props]
   (when (seq props)
     (.setPersonProperties posthog (clj->js props)))))

(re-frame/reg-event-fx
 :posthog/set-person-properties
 (fn [_ [_ props]]
   {:posthog/set-person-properties props}))

(reg-fx
 :posthog/group
 (fn [{:keys [group-type group-id props]}]
   (when (and (seq group-type)
              (seq group-id))
     (.group posthog group-type group-id (clj->js props)))))

(reg-fx
 :posthog/reset-user
 (fn [_]
   (.reset posthog)))

(reg-fx
 :posthog/capture
 (fn [{:keys [event props]}]
   (.capture posthog event (clj->js (or props {})))))

(re-frame/reg-event-fx
 :posthog/capture
 (fn [_ [_ capture]]
   {:posthog/capture capture}))
